import { Box, Chip, Typography } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";

export default function MitarbeiterTags({ fieldName, label, helperText }) {
  const { control, setValue, getValues } = useFormContext();
  
  // Watch the current field value
  const currentValue = useWatch({
    control,
    name: fieldName,
  }) || "";
  
  // Watch the employee list from Zuständigkeiten
  const mitarbeiterListe = useWatch({
    control,
    name: "mitarbeiterListe",
  }) || [];

  // Filter only complete employees (with both name and personalnummer)
  const vollstaendigeMitarbeiter = mitarbeiterListe.filter(
    (m) => m.name && m.personalnummer
  );

  const handleMitarbeiterClick = (mitarbeiterString) => {
    const currentText = currentValue || "";
    
    // If the employee is already in the text, remove them
    if (currentText.includes(mitarbeiterString)) {
      const updatedText = currentText
        .replace(mitarbeiterString, "")
        .replace(/,\s*,/g, ",") // Remove double commas
        .replace(/^,\s*/, "") // Remove leading comma
        .replace(/,\s*$/, "") // Remove trailing comma
        .trim();
      setValue(fieldName, updatedText);
    } else {
      // Add the employee to the text
      const separator = currentText ? ", " : "";
      const updatedText = currentText + separator + mitarbeiterString;
      setValue(fieldName, updatedText);
    }
  };

  if (vollstaendigeMitarbeiter.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600 }}>
        {label}
      </Typography>
      {helperText && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {helperText}
        </Typography>
      )}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {vollstaendigeMitarbeiter.map((mitarbeiter, index) => {
          const mitarbeiterString = `${mitarbeiter.name} (${mitarbeiter.personalnummer})`;
          const isSelected = currentValue.includes(mitarbeiterString);
          
          return (
            <Chip
              key={index}
              label={mitarbeiterString}
              clickable
              color={isSelected ? "primary" : "default"}
              variant={isSelected ? "filled" : "outlined"}
              onClick={() => handleMitarbeiterClick(mitarbeiterString)}
              sx={{ mb: 1 }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
